import type { AdditionalScreenerFilter } from '@/hooks/useInfiniteCompanyScreenersQuery/types';
import { getIndustryIdFromSlug } from '@/pages/Screener/functions';
type GetAdditionalFiltersParams = {
  market: string;
  industry: string;
};

export const getAdditionalFilters = ({
  market,
  industry,
}: GetAdditionalFiltersParams): AdditionalScreenerFilter[] => {
  const marketValue = market === 'global' ? '' : market;
  const industryId = getIndustryIdFromSlug(industry);
  return [
    {
      field: 'country_name',
      operator: 'in',
      logicalCondition: 'aor',
      values: [marketValue].filter(Boolean),
    },
    {
      field: 'primary_industry_id',
      operator: 'in',
      logicalCondition: 'aor',
      values: [industryId].filter(Boolean),
    },
  ];
};
